import { LngLat, LngLatBounds } from 'mapbox-gl';

export interface BoundablePoint {
  latitude?: number | null;
  longitude?: number | null;
}

const getBoundsFromVisitLocations = (locations: BoundablePoint[] = []): LngLatBounds | null => {
  if (locations.length === 0) return null;

  const validLocations = locations.filter(location =>
    location.longitude != null && location.latitude != null,
  );

  if (validLocations.length === 1) {
    const { longitude, latitude } = validLocations[0];
    return new LngLat(longitude!, latitude!).toBounds(200); // Adjust if needed
  }

  const bounds = new LngLatBounds();
  validLocations.forEach(({ longitude, latitude }) => {
    bounds.extend(new LngLat(longitude!, latitude!));
  });

  return bounds.isEmpty() ? null : bounds;
};

export default getBoundsFromVisitLocations;
